import moment from 'moment'
import type { Appointment } from 'app/generated/graphql'

// Carestack has no confirmed flag; it writes confirmation into the status text, which the API folds into `Scheduled`.
const CONFIRMED_PMS_STATUSES: readonly string[] = [
  `Appointment Confirmed`,
  `Confirmed`,
  `Confirmed Electronically`,
  `Confirmed via Text`,
]

export function isAppointmentConfirmed(
  appointment: Pick<Appointment, `status` | `pmsStatus` | `date` | `confirmed`>,
  now: Date = new Date(),
): boolean {
  if (appointment.status !== `Scheduled` || !appointment.date) return false
  // `date` is the visit's day at UTC midnight, so the day is compared as text, never shifted into local time.
  if (appointment.date.slice(0, 10) < moment(now).format(`YYYY-MM-DD`)) return false
  return appointment.confirmed === true || CONFIRMED_PMS_STATUSES.includes(appointment.pmsStatus?.trim() ?? ``)
}
